import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class DailySalesReportAPI {

  static list = (model, filters, success, failure) => {
    const body = { model: model, filters: filters };
    fetch(Config.app.link + 'api/getDailyLeads', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static getDailyLeadsStatus = (filters, success, failure) => {
    const body = { filters: filters };
    fetch(Config.app.link + 'api/getDailyLeadsStatus', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getDailyLeadSource = (filters, success, failure) => {
    const body = { filters: filters };
    fetch(Config.app.link + 'api/getDailyLeadSource', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getDailyLeadsByProject = (filters, success, failure) => {
    const body = { filters: filters };
    fetch(Config.app.link + 'api/getDailyLeadsByProject', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getCallTalktime = (filters, success, failure) => {
    const body = { filters: filters };
    fetch(Config.app.link + 'api/getCallTalktime', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getCallfeedback = (filters, success, failure) => {
    const body = { filters: filters };
    fetch(Config.app.link + 'api/getCallFeedback', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getMeetingfeedback = (filters, success, failure) => {
    const body = { filters: filters };
    fetch(Config.app.link + 'api/getMeetingFeedback', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getMeetingByProject = (filters, success, failure) => {
    const body = { filters: filters };
    fetch(Config.app.link + 'api/getMeetingByProject', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getCallsInOut = (filters, success, failure) => {
    const body = { filters: filters };
    fetch(Config.app.link + 'api/getCallsInOut', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getleadsByPropertyType = (filters, success, failure) => {
    const body = { filters: filters };
    fetch(Config.app.link + 'api/getleadsByPropertyType', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getleadsByRentSale = (filters, success, failure) => {
    const body = { filters: filters };
    fetch(Config.app.link + 'api/getleadsByRentSale', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getPropertyBySalesPerson = (filters, success, failure) => {
    const body = { filters: filters };
    fetch(Config.app.link + 'api/getPropertyBySalesPerson', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getFixedReport = (body, success, failure) => {
    fetch(Config.app.link + 'api/fixed-report/Fixedreport', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getFixedreportWithDoubleModel = (body, success, failure) => {
    fetch(Config.app.link + 'api/fixed-report/FixedreportWithDoubleModel', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static getFixedConsolidatedReport = (body, success, failure) => {
    fetch(Config.app.link + 'api/fixed-report/ConsolidatedReport', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };
  static LeadSiteVisitReportMonthWiseRatio = (body, success, failure) => {
    fetch(Config.app.link + 'api/fixed-report/leadSiteVisitReportMonthWiseRatio', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

  static getDailyAttendenceReport = (body, success, failure) => {
    fetch(Config.app.link + 'api/getDailyAttendenceReport', new Header('POST', body))
      .then(res => Const.ProcessAPI(res, success, failure))
      .catch(er => failure(er));
  };

}

export default DailySalesReportAPI;